import React from 'react'

import {
  useTrainingEventActions,
  TrainingEventActions,
  trainingEventContextActions,
} from './TrainingEvent.actions'
import { DNAContextMenu } from '@alucio/lux-ui'
import { TrainingEventORM } from 'src/types/orms'

export interface TrainingEventContextMenuProps {
  trainingEvent: TrainingEventORM
  actions?: TrainingEventActions[],
  children: React.ReactElement,
}

export const TrainingEventContextMenu: React.FC<TrainingEventContextMenuProps> = (props) => {
  const {
    trainingEvent,
    actions,
    children,
  } = props

  const trainingEventActions = useTrainingEventActions()
  const actionsToUse: TrainingEventActions[] = [
    'edit',
    'delete',
  ]

  return (
    <DNAContextMenu>
      <DNAContextMenu.Anchor>
        { children }
      </DNAContextMenu.Anchor>
      <DNAContextMenu.Items>
        {
          (actions ?? actionsToUse).map(action => {
            const { onPress, ...rest } = trainingEventContextActions[action];
            return (
              <DNAContextMenu.Item
                key={action}
                onPress={trainingEventActions[action](trainingEvent.model)}
                {...rest}
              />
            )
          })
        }
      </DNAContextMenu.Items>
    </DNAContextMenu>
  )
}

export default TrainingEventContextMenu
